import { render, staticRenderFns } from "./support-settings.vue?vue&type=template&id=5061596a"
import script from "./support-settings.vue?vue&type=script&lang=ts"
export * from "./support-settings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports